// @ts-nocheck
import React from 'react';

export default function ProfilePage() {
  // Minimal focused view; assumes Supabase auth elsewhere
  return (
    <div className="max-w-xl mx-auto space-y-4">
      <h1 className="text-xl font-semibold">Your profile</h1>
      <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-4">
        <div className="text-sm text-gray-500">Signed in as</div>
        <div className="font-medium">{/* user email/handle placeholder */}you@example.com</div>
      </div>
      <div className="rounded-xl border border-gray-200 dark:border-gray-800 p-4">
        <div className="text-sm font-medium mb-1">Privacy</div>
        <div className="text-sm text-gray-500">Control who can see your default visibility and sharing options in Settings.</div>
      </div>
    </div>
  );
}
